const MAX_ATTEMPTS = 10
const MIN_ATTEMPTS_INDICATED = 5

const DEFAULT_STATE = {
  message: undefined,
  messageType: 'error',
  blockedFor: undefined,
  remainingAttempts: undefined,
  maxAttempts: MAX_ATTEMPTS,
  isLastAttempt: false,
  isButtonDisabled: false,
  errorType: []
}

export function makeLoginErrorState(error) {
  const state = { ...DEFAULT_STATE }

  if (typeof error === 'undefined') {
    return state
  }

  if (error?.errorType) {
    state.errorType = error.errorType
  }

  const { messages, blockedFor, failed = 0 } = error?.response?.data

  state.message = messages[0]
  state.blockedFor = blockedFor
  state.isLastAttempt = failed === MAX_ATTEMPTS - 1
  // prettier-ignore
  state.remainingAttempts = failed >= MIN_ATTEMPTS_INDICATED
      ? MAX_ATTEMPTS - failed
      : undefined

  if (blockedFor || failed >= MAX_ATTEMPTS) {
    state.isButtonDisabled = true
    state.messageType = 'warning'
  }

  return state
}
